// Five-swatch accent picker — PRD 08 §10.1. Each swatch maps to one of the
// preset slugs (rust / teal / violet / forest / slate). Hex picker + WCAG
// guardrails defer to v1.2.

import type { AccentSlug } from "../../data/types";

const SWATCHES: ReadonlyArray<{ slug: AccentSlug; hex: string; label: string }> = [
  { slug: "rust",   hex: "#ff8a3d", label: "Rust" },
  { slug: "teal",   hex: "#40b2af", label: "Teal" },
  { slug: "violet", hex: "#9a82dc", label: "Violet" },
  { slug: "forest", hex: "#56a163", label: "Forest" },
  { slug: "slate",  hex: "#94a8c4", label: "Slate" },
];

export interface AccentSwatchPickerProps {
  value: AccentSlug;
  onChange: (next: AccentSlug) => void;
  disabled?: boolean;
}

export function AccentSwatchPicker({
  value,
  onChange,
  disabled,
}: AccentSwatchPickerProps) {
  return (
    <div className="maisight-accent-picker" role="radiogroup" aria-label="Accent color">
      {SWATCHES.map(({ slug, hex, label }) => {
        const selected = slug === value;
        return (
          <button
            key={slug}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={label}
            className={`maisight-accent-swatch${selected ? " is-selected" : ""}`}
            style={{ background: hex }}
            disabled={disabled}
            onClick={() => onChange(slug)}
          />
        );
      })}
    </div>
  );
}
